import { n as native } from './native-WLH4MKOt.js';
import { r as rng } from './rng-Cx3iSsDS.js';
import { u as unsafeStringify } from './stringify-CCpQ5U_c.js';

function v4(options, buf, offset) {
    if (native.randomUUID && true && !options) {
        return native.randomUUID();
    }
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    return unsafeStringify(rnds);
}

export { v4 as v };
//# sourceMappingURL=v4-s8qJzEVD.js.map
